import './App.css';
import Header from './Components/Header'
import LeftBar from './Components/LeftBar'
import Body from './Components/Body'
import RightBar from './Components/RightBar'

function App() {
  return (
    <div className="app">
      <LeftBar />
      <div className="header__body">
        <Header />
        <Body />
      </div>
      <RightBar />

    </div>
  );
}

export default App;